module.exports = __webpack_public_path__ + "static/media/postgresql.f16a2cda.svg";